import React, { useState } from "react";
import Select from "react-select";

export default function MedicalHistory({ data, doctors = [], onChange }) {
  const [symptoms, setSymptoms] = useState(
    data?.current_symptoms.map((symptom) => ({
      label: symptom,
      value: symptom,
    })) || []
  );
  const [assignedDoctors, setAssignedDoctors] = useState(
    data?.assigned_doctors?.map((doctorId) => {
      const doctor = doctors?.find((d) => d.id === doctorId);
      return {
        label: `${doctor.name} - ${doctor.specialization}`,
        value: doctorId,
      };
    }) || []
  );

  const handleInputChange = (key, value) => {
    onChange({
      ...data,
      [key]: value,
    });
  };

  const handleSymptomsChange = (selectedOptions) => {
    const updatedSymptoms = selectedOptions.map((option) => option.value);
    setSymptoms(selectedOptions);
    handleInputChange("current_symptoms", updatedSymptoms);
  };

  const handleDoctorsChange = (selectedOptions) => {
    const updatedDoctors = selectedOptions?.map((option) => option.value);
    setAssignedDoctors(selectedOptions);
    handleInputChange("assigned_doctors", updatedDoctors);
  };

  return (
    <div>
      <h2 className="text-xl font-bold mb-4">Medical History</h2>
      <div className="grid grid-cols-2 gap-6">
        <div>
          <label className="block mb-1">Pre-existing Conditions</label>
          <textarea
            value={data?.preexisting_conditions || ""}
            onChange={(e) =>
              handleInputChange("preexisting_conditions", e.target.value)
            }
            className="w-full border border-gray-300 rounded-md p-2"
            placeholder="Enter Pre-existing Conditions"
          ></textarea>
        </div>
        <div>
          <label className="block mb-1">Allergies</label>
          <textarea
            value={data?.allergies || ""}
            onChange={(e) => handleInputChange("allergies", e.target.value)}
            className="w-full border border-gray-300 rounded-md p-2"
            placeholder="Enter Allergies"
          ></textarea>
        </div>
        <div>
          <label className="block mb-1">Medications</label>
          <textarea
            value={data?.current_medication || ""}
            onChange={(e) =>
              handleInputChange("current_medication", e.target.value)
            }
            className="w-full border border-gray-300 rounded-md p-2"
            placeholder="Enter Current Medications"
          ></textarea>
        </div>
        <div>
          <label className="block mb-1">Past Surgical History</label>
          <textarea
            value={data?.past_surgical_history || ""}
            onChange={(e) =>
              handleInputChange("past_surgical_history", e.target.value)
            }
            className="w-full border border-gray-300 rounded-md p-2"
            placeholder="Enter Past Surgeries"
          ></textarea>
        </div>
        <div>
          <label className="block mb-1">Immunization History</label>
          <textarea
            value={data?.immunization_history || ""}
            onChange={(e) =>
              handleInputChange("immunization_history", e.target.value)
            }
            className="w-full border border-gray-300 rounded-md p-2"
            placeholder="Enter Immunization Details"
          ></textarea>
        </div>
        <div>
          <label className="block mb-1">Family Medical History</label>
          <textarea
            value={data?.family_medical_history || ""}
            onChange={(e) =>
              handleInputChange("family_medical_history", e.target.value)
            }
            className="w-full border border-gray-300 rounded-md p-2"
            placeholder="Enter Family Medical History"
          ></textarea>
        </div>
      </div>

      {/* Current Symptoms Section */}
      <div className="mt-6">
        <label className="block mb-1 text-lg font-semibold">
          Current Symptoms
        </label>
        <Select
          isMulti
          value={symptoms}
          onChange={handleSymptomsChange}
          options={symptoms?.map((s) => ({ label: s.value, value: s.value }))}
          placeholder="Select or Add Symptoms"
          classNamePrefix="react-select"
        />
      </div>

      {/* Assign Doctors Section */}
      <div className="mt-6">
        <label className="block mb-1 text-lg font-semibold">
          Assign Doctors
        </label>
        <Select
          isMulti
          value={assignedDoctors}
          onChange={handleDoctorsChange}
          options={doctors?.map((doctor) => ({
            label: `${doctor.name} - ${doctor.specialization}`,
            value: doctor.id,
          }))}
          placeholder="Select Doctors"
          classNamePrefix="react-select"
        />
      </div>
    </div>
  );
}
